<script setup lang="ts">
// Mini-formulaire d'accueil : transmet le type et la date de l'événement à /devis (préremplis à l'étape 2).
const eventTypes = [
  { label: 'Festival / concert', value: 'festival' },
  { label: 'Événement sportif', value: 'sport' },
  { label: 'Manifestation communale / brocante', value: 'commune' },
  { label: 'Salon / séminaire d\'entreprise', value: 'entreprise' },
  { label: 'Autre événement', value: 'autre' },
]

const type = ref<string | undefined>(undefined)
const date = ref('')
const today = new Date().toISOString().slice(0, 10)

async function submit() {
  const query: Record<string, string> = {}
  if (type.value && type.value !== 'autre') {
    query.type = type.value
  }
  if (date.value) {
    query.date = date.value
  }
  useTrackEvent('Quote: QuickStart', { props: { type: type.value ?? 'non_precise', date: date.value ? 'oui' : 'non' } })
  await navigateTo({ path: '/devis', query })
}
</script>

<template>
  <section
    id="devis-rapide"
    class="public-content"
  >
    <div class="mx-auto max-w-7xl px-6 md:px-12 xl:px-6">
      <form
        class="public-card grid gap-4 p-6 md:grid-cols-12 md:items-end md:p-8"
        @submit.prevent="submit"
      >
        <div class="md:col-span-12">
          <h2 class="public-h3">
            Démarrez votre devis en 10 secondes.
          </h2>
          <p class="public-muted mt-1 text-sm">
            Deux informations suffisent pour commencer, le reste se complète ensuite.
          </p>
        </div>
        <UFormField
          label="Type d'événement"
          class="md:col-span-5"
        >
          <USelect
            v-model="type"
            :items="eventTypes"
            placeholder="Choisir un type"
            size="xl"
            class="w-full"
          />
        </UFormField>
        <UFormField
          label="Date de début"
          class="md:col-span-4"
        >
          <UInput
            v-model="date"
            type="date"
            :min="today"
            size="xl"
            class="w-full"
          />
        </UFormField>
        <UButton
          type="submit"
          size="xl"
          label="Continuer vers le devis"
          trailing-icon="i-heroicons-arrow-right"
          class="justify-center md:col-span-3"
        />
      </form>
    </div>
  </section>
</template>
